export const Filter = {
  BusinessUnitId: "businessUnitId" as const,
  BusinessUnitName: "businessUnitName" as const,
  BusinessUnitManagerId: "businessUnitManagerId" as const,
  ManagerName: "managerName" as const,
  Period: "period" as const,
}

export const Create = {
  BusinessUnitName: "businessUnitName" as const,
  ManagerId: "managerId" as const,
  ManagerName: "managerName" as const,
  Members: "members" as const,
  ManagerHasSalaryRights: "managerHasSalaryRights" as const,
}

export const Update = {
  Id: "id" as const,
}

export const BusinessUnitMember = {
  EmployeeId: "employeeId" as const,
  Name: "name" as const,
}

